import { useEffect, useState } from "react";
import {
  Layout,
  Menu,
  Avatar,
  Dropdown,
  Button,
  Select,
  Row,
  Col,
  Checkbox,
  Popconfirm,
} from "antd";
import "./layout-app.less";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ChangePasswordModal } from "modules/account/components/change-password-modal";
import {
  CoreResource,
  getCurrentCulture,
  setCurrentCulture,
  t,
} from "shared/plugins/localization";
import {
  BranchText,
  SelectTheField,
} from "shared/constants/define-localization";
import _ from "lodash";
import { setCurrentBranch } from "states/branch/branch.slice";
import { RootState } from "app.store";
import { logout } from "states/account/account.slice";
import { setIsAutoPrintOrderOnline } from "states/global-value/global-value.slice";
const { Header } = Layout;

const HeaderApp = () => {
  const dispatch = useDispatch();
  const branchList = useSelector(
    (state: RootState) => state.branch.branchList,
    shallowEqual
  );
  const [visibleModal, setVisibleModal] = useState<boolean>(false);
  const [cultureLocal, setCultureLocal] = useState<string>("");
  const currentBranch = useSelector(
    (state: RootState) => state.branch.currentBranch,
    shallowEqual
  );
  const onToggleModal = () => {
    setVisibleModal(false);
  };
  const currentStaff = useSelector(
    (state: RootState) => state.account.currentStaff,
    shallowEqual
  );
  const currentUser = useSelector(
    (state: RootState) => state.account.currentUser,
    shallowEqual
  );
  const autoPrintOrderOnline = useSelector(
    (state: RootState) => state.globalValue.autoPrintOrderOnline,
    shallowEqual
  );

  const accountMenu = () => {
    return (
      <Menu>
        <Menu.Item>
          <Button
            type="text"
            block={true}
            onClick={() => setVisibleModal(true)}
          >
            Change password
          </Button>
        </Menu.Item>
        <Menu.Item>
          <Button
            type="text"
            block={true}
            onClick={() => {
              dispatch(logout());
            }}
          >
            Log out
          </Button>
        </Menu.Item>
      </Menu>
    );
  };
  const _handleChangeLanguage = async (culture: string) => {
    if (cultureLocal === culture) {
      return false;
    }
    setCurrentCulture(culture);
    setCultureLocal(culture);
    window.location.reload();
  };

  const _handleChangeBranch = async (branchId?: number) => {
    if (currentBranch.id === branchId) {
      return;
    }
    const branch = branchList.find((m) => m.id === branchId);
    if (branch) {
      dispatch(setCurrentBranch(branch));
    }
  };

  // const languageMenu = (
  //   <Menu
  //     onClick={(value) => {
  //       _handleChangeLanguage(value.key.toString());
  //     }}
  //   >
  //     <Menu.Item
  //       key="vi"
  //       icon={
  //         <img className="br-1 mr-1" src={VnIcon} width={20} alt="Vietnamese" />
  //       }
  //     >
  //       Vietnamese
  //     </Menu.Item>
  //     <Menu.Item
  //       key="en"
  //       icon={
  //         <img className="br-1 mr-1" src={UsIcon} width={20} alt="English" />
  //       }
  //     >
  //       English
  //     </Menu.Item>
  //   </Menu>
  // );
  useEffect(() => {
    setCultureLocal(getCurrentCulture());
  }, []);
  return (
    <Header className="main-header">
      <div className="main-header__r flex justify-content-center justify-content-end">
        <div>
          {/* <Popconfirm
              title={
                (autoPrintOrderOnline ? "Turn off" : "Turn on") + " auto print?"
              }
              onConfirm={(e) => {
                dispatch(setIsAutoPrintOrderOnline(!autoPrintOrderOnline));
              }}
            >
              <Checkbox checked={autoPrintOrderOnline}>
                Auto Print Order Online
              </Checkbox>
            </Popconfirm> */}
        </div>
        <div className="branch-selector mr-2">
          <Select
            style={{ width: 300 }}
            placeholder={t(
              CoreResource,
              SelectTheField,
              t(CoreResource, BranchText)
            )}
            onChange={(item) => {
              _handleChangeBranch(item);
            }}
            value={currentBranch?.id}
            showSearch
            filterOption={(input, option: any) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {branchList &&
              branchList
                .filter(
                  (m) =>
                    currentUser &&
                    currentStaff &&
                    (currentStaff.isAccessAllBranch ||
                      currentUser.roles.filter((r) => r.name === "Admin")
                        .length > 0 ||
                      currentStaff.branchIds.filter((b) => b === m.id).length >
                        0)
                )
                .map((t) => (
                  <Select.Option key={t.id} value={t.id}>
                    {t.name}
                  </Select.Option>
                ))}
          </Select>
        </div>
        {/* <div className="multi-language mr-2">
            <Dropdown overlay={languageMenu} trigger={["click"]}>
              <Button type="text">
                <SwitchDefaultLanguage currentCulture={cultureLocal} />{" "}
                <DownOutlined />
              </Button>
            </Dropdown>
          </div> */}
        <div className="tools">
          <Dropdown
            overlay={accountMenu}
            placement="bottomRight"
            trigger={["click"]}
          >
            <Avatar className="avatar">{currentStaff?.firstName[0]}</Avatar>
          </Dropdown>
          <ChangePasswordModal
            visible={visibleModal}
            onCancel={() => onToggleModal()}
          />
        </div>
      </div>
    </Header>
  );
};

export default HeaderApp;
